import { ITEMS, CHARACTERS, ACTIVE_BANNERS, PLAYER } from '../data';
import { ASSETS } from '../assetManifest';
import { BANNERS } from '../content/banners';
import { pullCharacter, pullItem } from '../utils/gameUtils';

export const getBannerData = () => {
  const banners = BANNERS.map(banner => {
    if (banner.highlight?.characterId) {
      return {
        ...banner,
        image: ASSETS.characters[banner.highlight.characterId].path,
      };
    } else {
      console.log(ASSETS.locations[banner.backgroundId] || ASSETS.backgrounds[banner.backgroundId]);
      return {
        ...banner,
        image: (ASSETS.locations[banner.backgroundId] || ASSETS.backgrounds[banner.backgroundId])?.path
      };
    }
  });

  return { 
    banners,
    premiumCurrency: PLAYER.resources.premiumCurrency
  };
};

export const performPull = (banner, count) => {
  const pulls = [];
  const { probabilities } = banner;
  PLAYER.resources.premiumCurrency -= banner.cost * count;

  for (let i = 0; i < count; i++) {
    const roll = Math.random();
    let selectedItem = null;
    let cumulativeProbability = 0;

    for (const prob of probabilities) {
      cumulativeProbability += prob.probability;
      
      if (roll < cumulativeProbability) {
        const poolIds = prob.poolIds;
        const randomPoolId = poolIds[Math.floor(Math.random() * poolIds.length)];
        selectedItem = randomPoolId;
        break;
      }
    }

    // Fallback to first item if somehow nothing was selected
    if (!selectedItem) {
      selectedItem = probabilities[0].poolIds[0];
    }

    if (CHARACTERS[selectedItem]) {
      pullCharacter(selectedItem);
    } else if (ITEMS[selectedItem]) {
      pullItem(selectedItem);
    }
    pulls.push(selectedItem);
  }

  return pulls;
};
